module.exports = __webpack_public_path__ + "static/media/eyeSquintRight.b994d123.obj";